// src/styles/buttonColors.ts

export type ButtonVariant =
  | "primary"
  | "secondary"
  | "dark"
  | "gray"
  | "light"
  | "warning"
  | "danger"
  | "success"
  | "info";

export const buttonColors: Record<ButtonVariant, { solid: string; outline: string }> = {
  primary: {
    solid: "bg-primary text-white",
    outline: "border border-primary text-primary bg-transparent",
  },
  secondary: {
    solid: "bg-[#13C296] text-white",
    outline: "border border-[#13C296] text-[#13C296] bg-transparent",
  },
  dark: {
    solid: "bg-[#212B36] text-white",
    outline: "border border-[#212B36] text-[#212B36] bg-transparent",
  },
  gray: {
    solid: "bg-[#637381] text-white",
    outline: "border border-[#637381] text-[#637381] bg-transparent",
  },
  light: {
    solid: "bg-[#EFEFEF] text-[#212B36]",
    outline: "border border-[#EFEFEF] text-[#212B36] bg-transparent",
  },
  warning: {
    solid: "bg-[#F9C107] text-[#212B36]",
    outline: "border border-[#F9C107] text-[#F9C107] bg-transparent",
  },
  danger: {
    solid: "bg-[#DC3545] text-white",
    outline: "border border-[#DC3545] text-[#DC3545] bg-transparent",
  },
  success: {
    solid: "bg-[#3CA745] text-white",
    outline: "border border-[#3CA745] text-[#3CA745] bg-transparent",
  },
  info: {
    solid: "bg-[#3BA2B8] text-white",
    outline: "border border-[#3BA2B8] text-[#3BA2B8] bg-transparent",
  },
};
